import { useEffect, useState } from 'react';

const layouts = [
  'vb-icon-layout-1',
  'vb-icon-layout-2',
  'vb-icon-layout-3',
  'vb-icon-layout-4',
  'vb-icon-layout-5',
  'vb-icon-layout-6',
  'vb-icon-layout-7',
];

const svg = {
  'vb-icon-layout-1': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-label="Mobile" role="graphics-symbol" stroke="currentColor" stroke-width="0.5px" stroke-dasharray="0, 0">
            <path d="M15 4H9c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm.5 14c0 .3-.2.5-.5.5H9c-.3 0-.5-.2-.5-.5V6c0-.3.2-.5.5-.5h6c.3 0 .5.2.5.5v12zm-4.5-.5h2V16h-2v1.5z" />
          </svg>`,

  'vb-icon-layout-2': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-label="Pin" role="graphics-symbol" stroke="currentColor" stroke-width="0.5px"  stroke-dasharray="0, 0"  "><path d="m21.5 9.1-6.6-6.6-4.2 5.6c-1.2-.1-2.4.1-3.6.7-.1 0-.1.1-.2.1-.5.3-.9.6-1.2.9l3.7 3.7-5.7 5.7v1.1h1.1l5.7-5.7 3.7 3.7c.4-.4.7-.8.9-1.2.1-.1.1-.2.2-.3.6-1.1.8-2.4.6-3.6l5.6-4.1zm-7.3 3.5.1.9c.1.9 0 1.8-.4 2.6l-6-6c.8-.4 1.7-.5 2.6-.4l.9.1L15 4.9 19.1 9l-4.9 3.6z" /></svg>`,

  'vb-icon-layout-3':`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" 
		aria-label="Cloud Upload" role="graphics-symbol" 
		stroke="currentColor" stroke-width="0.5px" 
		stroke-dasharray="0, 0"  "><path d="M17.3 10.1C17.3 7.60001 15.2 5.70001 12.5 5.70001C10.3 5.70001 8.4 7.10001 7.9 9.00001H7.7C5.7 9.00001 4 10.7 4 12.8C4 14.9 5.7 16.6 7.7 16.6H9.5V15.2H7.7C6.5 15.2 5.5 14.1 5.5 12.9C5.5 11.7 6.5 10.5 7.7 10.5H9L9.3 9.40001C9.7 8.10001 11 7.20001 12.5 7.20001C14.3 7.20001 15.8 8.50001 15.8 10.1V11.4L17.1 11.6C17.9 11.7 18.5 12.5 18.5 13.4C18.5 14.4 17.7 15.2 16.8 15.2H14.5V16.6H16.7C18.5 16.6 19.9 15.1 19.9 13.3C20 11.7 18.8 10.4 17.3 10.1Z M14.1245 14.2426L15.1852 13.182L12.0032 10L8.82007 13.1831L9.88072 14.2438L11.25 12.8745V18H12.75V12.8681L14.1245 14.2426Z" /></svg>`,

  'vb-icon-layout-4':`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" 
		aria-label="Mail" role="graphics-symbol" 
		stroke="currentColor" stroke-width="0.5px" 
		stroke-dasharray="0, 0"  "><path d="M20,4H4C2.895,4,2,4.895,2,6v12c0,1.105,0.895,2,2,2h16c1.105,0,2-0.895,2-2V6C22,4.895,21.105,4,20,4z M20,8.236l-8,4.882 L4,8.236V6h16V8.236z" /></svg>`,

  'vb-icon-layout-5':`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" 
		aria-label="Add Card" role="graphics-symbol" 
		stroke="currentColor" stroke-width="0.5px" 
		stroke-dasharray="0, 0"  "><path d="M18.5 5.5V8H20V5.5h2.5V4H20V1.5h-1.5V4H16v1.5h2.5zM12 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2v-6h-1.5v6a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5V6a.5.5 0 01.5-.5h6V4z" /></svg>`,

  'vb-icon-layout-6':`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" 
		aria-label="Bolt" role="graphics-symbol" 
		stroke="currentColor" stroke-width="0.3px" 
		stroke-dasharray="4, 2"  "><path d="m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z" /></svg>`,
  
  'vb-icon-layout-7': `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" 
		aria-label="Settings" role="graphics-symbol" 
		stroke="currentColor" stroke-width="0.5px" 
		stroke-dasharray="0, 0"  "><path d="m19 7.5h-7.628c-.3089-.87389-1.1423-1.5-2.122-1.5-.97966 0-1.81309.62611-2.12197 1.5h-2.12803v1.5h2.12803c.30888.87389 1.14231 1.5 2.12197 1.5.9797 0 1.8131-.62611 2.122-1.5h7.628z" /><path d="m19 15h-2.128c-.3089-.8739-1.1423-1.5-2.122-1.5s-1.8131.6261-2.122 1.5h-7.628v1.5h7.628c.3089.8739 1.1423 1.5 2.122 1.5s1.8131-.6261 2.122-1.5h2.128z" /></svg>`,

}

const layoutSettings = {
  'vb-icon-layout-1': {
    iconsDropShadow:{},
    iconsBorder:{},
    color: "#FFF",
    advBackground:{
      type: "",
      color: "",
      image: {
          url: ""
      },
      gradient: "linear-gradient(135deg,#0F2027 0%, #203A43 0%, #2c5364 100%)"
    },
    iconName: "wordpress-mobile",
    backgroundcolor: 'linear-gradient(to right, #ff9966, #ff5e62)',
    iconSize:{
      Desktop: "58px",
      Mobile: "50px",
      Tablet: "50px"
    },
    iconsRadius: {
      Desktop: { topLeft: '10px', topRight: '10px', bottomLeft: '10px', bottomRight: '10px' },
      Tablet: { topLeft: '10px', topRight: '10px', bottomLeft: '10px', bottomRight: '10px' },
      Mobile: { topLeft: '10px', topRight: '10px', bottomLeft: '10px', bottomRight: '10px' },
    },
    iconpadding: {
      Desktop: {top: '5px', right: '5px', bottom: '5px', left: '5px',
      },
      Tablet: { top: '5px', right: '5px', bottom: '5px', left: '5px',
      },
      Mobile: { top: '5px', right: '5px', bottom: '5px', left: '5px',
      },
    },
  },

  'vb-icon-layout-2':{
    backgroundcolor: "#e65054",
    color: "#FFF",
    iconName: "wordpress-pin",
    iconSize: {Desktop: "55px",Mobile: "50px", Tablet: "50px"},
    iconpadding: {
      Desktop: {top: '5px', right: '5px', bottom: '5px', left: '5px',
      },
      Tablet: { top: '5px', right: '5px', bottom: '5px', left: '5px',
      },
      Mobile: { top: '5px', right: '5px', bottom: '5px', left: '5px',
      },
    },
    iconsBorder: { 
        Desktop: { color: "#fe6e73", style: "solid", width: "6px"
      },
      Tablet: { color: "#e65054", style: "solid", width: "9px"
      },
      Mobile: { color: "#e65054", style: "solid", width: "9px"
      }
    },
    iconsDropShadow:{
      Desktop: {
        css: "inset 0px 0px 20px 4px #fa9a9d",
        elements: {inset: "inset",color: "#fa9a9d",offsetX: "0px",offsetY: "0px",blur: "20px",spread: "4px",elevation: "default" }
      },
      Tablet: {
        css: "inset 0px 0px 20px 4px #fa9a9d",
        elements: {inset: "inset",color: "#fa9a9d",offsetX: "0px",offsetY: "0px",blur: "20px",spread: "4px",elevation: "default" }
      },
      Mobile: {
        css: "inset 0px 0px 20px 4px #fa9a9d",
        elements: {inset: "inset",color: "#fa9a9d",offsetX: "0px",offsetY: "0px",blur: "20px",spread: "4px",elevation: "default" }
      }
    },
    iconsRadius: {
      Desktop: { topLeft: '100px', topRight: '100px', bottomLeft: '100px', bottomRight: '100px' },
      Tablet: { topLeft: '100px', topRight: '100px', bottomLeft: '100px', bottomRight: '100px' },
      Mobile: { topLeft: '100px', topRight: '100px', bottomLeft: '100px', bottomRight: '100px' },
    },
  },

  'vb-icon-layout-3':{
    iconsDropShadow:{},
    iconsBorder:{},
    backgroundcolor: "linear-gradient(to right, #0575e6, #021b79)",
    color: "#FFF",
    iconName: "wordpress-cloudUpload",
    iconSize: {Desktop: "55px",Mobile: "50px", Tablet: "50px"},
    iconpadding: {
      Desktop: {top: '4px', right: '4px', bottom: '4px', left: '4px',
      },
      Tablet: { top: '4px', right: '4px', bottom: '4px', left: '4px',
      },
      Mobile: { top: '4px', right: '4px', bottom: '4px', left: '4px',
      },
    },
    iconsRadius: {
      Desktop: { topLeft: '20px', topRight: '3px', bottomLeft: '3px', bottomRight: '20px' },
      Tablet: { topLeft: '20px', topRight: '3px', bottomLeft: '3px', bottomRight: '20px' },
      Mobile: { topLeft: '20px', topRight: '3px', bottomLeft: '3px', bottomRight: '20px' },
    },
  },

  'vb-icon-layout-4':{
    iconsBorder:{},
    backgroundcolor: "#e051a9",
    color: "#FFF",
    iconName: "wordpress-mail",
    iconSize: {Desktop: "55px",Mobile: "50px", Tablet: "50px"},
    iconpadding: {
      Desktop: {top: '5px', right: '5px', bottom: '5px', left: '5px',},
      Tablet: { top: '5px', right: '5px', bottom: '5px', left: '5px',},
      Mobile: { top: '5px', right: '5px', bottom: '5px', left: '5px',},
    },
    iconsRadius: {
      Desktop: { topLeft: '14px', topRight: '14px', bottomLeft: '14px', bottomRight: '14px' },
      Tablet: { topLeft: '14px', topRight: '14px', bottomLeft: '14px', bottomRight: '14px' },
      Mobile: { topLeft: '14px', topRight: '14px', bottomLeft: '14px', bottomRight: '14px' },
    },
    iconsDropShadow:{
      Desktop: {
        css: "5px 5px 2px 0px #ffd0ed",
        elements: {inset: "outset",color: "#ffd0ed",offsetX: "5px",offsetY: "5px",blur: "2px",spread: "0px", elevation: "default"}
      },
      Tablet: {
        css: "5px 5px 2px 0px #ffd0ed",
        elements: {inset: "outset",color: "#ffd0ed",offsetX: "5px",offsetY: "5px",blur: "2px",spread: "0px", elevation: "default"}
      },
      Mobile: {
        css: "5px 5px 2px 0px #ffd0ed",
        elements: {inset: "outset",color: "#ffd0ed",offsetX: "5px",offsetY: "5px",blur: "2px",spread: "0px", elevation: "default"}
      }
    },
  },

  'vb-icon-layout-5':{
    iconsDropShadow:{},
    backgroundcolor: "#fcbb746e",
    color: "#fb923c",
    iconName: "wordpress-addCard",
    iconSize: {Desktop: "55px",Mobile: "50px", Tablet: "50px"},
    iconpadding: {
      Desktop: {top: '6px', right: '6px', bottom: '6px', left: '6px',},
      Tablet: { top: '6px', right: '6px', bottom: '6px', left: '6px',},
      Mobile: { top: '6px', right: '6px', bottom: '6px', left: '6px',},
    },
    iconsRadius: {
      Desktop: { topLeft: '8px', topRight: '8px', bottomLeft: '8px', bottomRight: '8px' },
      Tablet: { topLeft: '8px', topRight: '8px', bottomLeft: '8px', bottomRight: '8px' },
      Mobile: { topLeft: '8px', topRight: '8px', bottomLeft: '8px', bottomRight: '8px' },
    },
    iconsBorder: {
      Desktop: { color: "#fa913c9c",style: "solid"},
      Tablet: { color: "#fa913c9c",style: "solid"},
      Mobile: { color: "#fa913c9c",style: "solid"}
    }
  },

  'vb-icon-layout-6':{
    iconsDropShadow:{},
    iconsBorder:{},
    backgroundcolor: "linear-gradient(90deg,rgb(18,18,18) 0%,rgb(146,145,145) 0%,rgb(47,47,47) 100%)",
    color: "#FFF",
    iconName: "wordpress-bolt",
    iconSize: {Desktop: "55px",Mobile: "50px", Tablet: "50px"},
    iconpadding: {
      Desktop: {top: '9px', right: '9px', bottom: '9px', left: '9px',},
      Tablet: { top: '9px', right: '9px', bottom: '9px', left: '9px',},
      Mobile: { top: '9px', right: '9px', bottom: '9px', left: '9px',},
    },
    iconsRadius: {
      Desktop: { topLeft: '15px', topRight: '15px', bottomLeft: '15px', bottomRight: '15px' },
      Tablet: { topLeft: '15px', topRight: '15px', bottomLeft: '15px', bottomRight: '15px' },
      Mobile: { topLeft: '15px', topRight: '15px', bottomLeft: '15px', bottomRight: '15px' },
    },
   
  },

  'vb-icon-layout-7':{
    iconsBorder:{},
    backgroundcolor: "#00d084",
    color: "#adffde",
    iconName: "wordpress-settings",
    iconSize: {Desktop: "55px",Mobile: "50px", Tablet: "50px"},
    iconpadding: {
      Desktop: {top: '6px', right: '6px', bottom: '6px', left: '6px',},
      Tablet: { top: '6px', right: '6px', bottom: '6px', left: '6px',},
      Mobile: { top: '6px', right: '6px', bottom: '6px', left: '6px',},
    },
    iconsRadius: {
      Desktop: { topLeft: '43px', topRight: '43px', bottomLeft: '43px', bottomRight: '43px' },
      Tablet: { topLeft: '43px', topRight: '43px', bottomLeft: '43px', bottomRight: '43px' },
      Mobile: { topLeft: '43px', topRight: '43px', bottomLeft: '43px', bottomRight: '43px' },
    },
    iconsDropShadow:{
      Desktop: {
        css: "inset 3px -7px 6px 1px #04b385",
        elements : {inset: "inset",color: "#04b385",offsetX: "3px",offsetY: "-7px",blur: "6px",spread: "1px",elevation: "default"},
      },
      Tablet: {
        css: "inset 3px -7px 6px 1px #04b385",
        elements : {inset: "inset",color: "#04b385",offsetX: "3px",offsetY: "-7px",blur: "6px",spread: "1px",elevation: "default"},
      },
      Mobile: {
        css: "inset 3px -7px 6px 1px #04b385",
        elements : {inset: "inset",color: "#04b385",offsetX: "3px",offsetY: "-7px",blur: "6px",spread: "1px",elevation: "default"},
      }
    },
   
  },
};

export const Layouts = ({ attributes, setAttributes }) => {
  const [canRestore, setCanRestore] = useState(false);
  const blockId = attributes?.uniqueId || 'default-block-id';
  const historyKey = `vb-icon-layout-history-${blockId}`;

  // Check if restore is possible on mount
  useEffect(() => {
    const history = JSON.parse(localStorage.getItem(historyKey)) || [];
    setCanRestore(history.length > 0);
  }, [blockId]);

  const onSelectClass = (layoutKey) => {
    if (layoutSettings[layoutKey]) {
      // Get layout history
      const history = JSON.parse(localStorage.getItem(historyKey)) || [];

      // Push current state into history
      history.push(attributes);
      localStorage.setItem(historyKey, JSON.stringify(history));
      setCanRestore(true);

      // Apply new layout
      const updated = { ...layoutSettings[layoutKey], layout: layoutKey };
      setAttributes(updated);
    }
  };

  const onRestore = () => {
    const history = JSON.parse(localStorage.getItem(historyKey)) || [];

    if (history.length > 0) {
      const prevState = history.pop();
      localStorage.setItem(historyKey, JSON.stringify(history));
      setAttributes(prevState);
      setCanRestore(history.length > 0);
    }
  };

  const onRefresh = () => {
    const currentLayout = attributes.layout || layouts[0];
    const defaultSettings = layoutSettings[currentLayout];

    if (defaultSettings) {
      // Optional: Clear history on refresh
      // localStorage.removeItem(historyKey);
      setAttributes({
        backgroundcolor: "",
        color: "",
        iconName: "wordpress-settings",
        iconSize: { Desktop: "50px", Mobile: "50px", Tablet: "50px" },
        iconpadding: {},
        iconsRadius: {},
        iconsDropShadow: {},
        iconsBorder: {}
      });
    }
  };

  return (
    <>
      <div className="layout-picker-grid">
        {layouts.map((layoutClass, index) => (
          <div
            key={index}
            className={`layout-icon ${layoutClass}`}
            onClick={() => onSelectClass(layoutClass)}
          >
            <div
              className={`vb-ion-layout vb-icon-${layoutClass}`}
              dangerouslySetInnerHTML={{ __html: svg[layoutClass] || '' }}
            />
          </div>
        ))}
      </div>

      <div className="vb-restore-layout-icon">
        {canRestore && (
          <button variant="secondary" onClick={onRestore}>
            Restore
          </button>
        )}
        <button variant="secondary" onClick={onRefresh}>
          Reset
        </button>
      </div>
    </>
  );
};